<template>
  <div class="city-picker-ui">
    <PopupUI
      v-if="typeDevice === 'mobile'"
      :disable-body-scroll="false"
      :inner-scroll-mobile="true"
      @on-close="onClosePopup"
    >
      <ConfirmationCityPicker
        v-if="typeCityPicker === 'confirmation'"
        :location="location"
        :city="city"
        @on-edit="onEditCity"
        @on-close="onClose"
      />
      <SelectCityPicker
        v-if="typeCityPicker === 'select-city'"
        :type-device="typeDevice"
        @on-close="onClose"
      />
    </PopupUI>

    <template v-else>
      <span
        class="city-picker-ui__close"
        @click="onClosePopup"
      >
        <Icon icon="r-close-window-rounded" />
      </span>
      <ConfirmationCityPicker
        v-if="typeCityPicker === 'confirmation'"
        :location="location"
        :city="city"
        @on-edit="onEditCity"
        @on-close="onClose"
      />
      <SelectCityPicker
        v-if="typeCityPicker === 'select-city'"
        :type-device="typeDevice"
        @on-close="onClose"
      />
    </template>
  </div>
</template>

<script>
import { getTypeDevice, sendEventYM } from '../../../utils/common';
import PopupUI from '../common/PopupUI.vue';
import Icon from '../common/Icon.vue';
import '../../../../../svg-icons/r-close-window-rounded.svg';

import ConfirmationCityPicker from './ConfirmationCityPicker.vue';
import SelectCityPicker from './SelectCityPicker.vue';

export default {
  name       : 'CityPickerUI',
  components : {
    Icon,
    PopupUI,
    SelectCityPicker,
    ConfirmationCityPicker
  },
  props: {
    location: {
      type     : Object,
      required : true,
      default  : null
    },
    isShowNotify: {
      type    : Boolean,
      default : false
    },
    city: {
      type    : String,
      default : ''
    }
  },
  data() {
    return {
      typeDevice     : '',
      oldTypeDevice  : '',
      options        : null,
      typeCityPicker : null
    };
  },

  created() {
    this.typeCityPicker = this.isShowNotify ? 'confirmation' : 'select-city';

    // Определяем тип устройства
    this.setTypeDevice();
    window.addEventListener('resize', this.setTypeDevice);
  },

  destroyed() {
    window.removeEventListener('resize', this.setTypeDevice);
  },

  methods: {
    setTypeDevice() {
      this.oldTypeDevice = this.typeDevice;
      this.typeDevice = getTypeDevice();
    },

    onEditCity() {
      this.typeCityPicker = 'select-city';
    },

    onClose() {
      const contentCityPickerUI = document.querySelector('[data-content-city-picker-ui]');
      if (contentCityPickerUI) {
        contentCityPickerUI.classList.remove('open');
        document.querySelector('body').classList.remove('open-city-picker');
        this.typeCityPicker = 'select-city';
      }
    },

    onClosePopup() {
      sendEventYM('confirmed_city_choice', {
        confirmed_city_choice_param: 'close'
      });

      this.onClose();
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../../../../css/redesign/utils/variables";
@import "../../../../../css/redesign/utils/grid";

.city-picker-ui {
  @include media-breakpoint-up(sm) {
    width: 464px;
    padding: 32px;
    border-radius: 16px;
    box-shadow: 0 6px 16px 0 rgba(0, 53, 149, 0.08);
    color: $c-blue-common;
    background-color: $c-white;
  }
  &__close {
    @include media-breakpoint-up(sm) {
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      top: 23px;
      right: 32px;
      width: 24px;
      height: 24px;
      cursor: pointer;
    }
  }
}
</style>
